module.exports = __webpack_public_path__ + "img/logo-white.64d1a5a0.png";